<template>
  <div class="card monthly-collisions">
    <h2 class="card-h2 s-icon">
      <span><i class="material-icons card-icon">warning</i> Monthly Collisions</span>
    </h2>
    <div class="card-content">
      <LineChart :chart-data="monthlyCollisions"
               :chart-data-label-y="'Number of collisions'"
               :chart-data-label-x="'Months'"
               :legend="legend"
               :additional-datasets="additionalDatasets"
               :line-color="lineColor" 
               :border-width="'1'"
               :background-color="backgroundColor"
               :point-border-color="pointBorderColor"
               :point-background-color="pointBackgroundColor"></LineChart>
    </div>
  </div>
</template>

<script>
import LineChart from '@/components/LineChart'

export default {
  name: 'monthlyCollisions',

  components: {
    'LineChart': LineChart
  },

  props: {
    'getters': {
      type: Object,
      required: true
    }
  },

  computed: {
    additionalDatasets () {
      let vm = this
      return [
        {
          pointRadius: 0,
          pointHoverRadius: 0,
          borderDash: [10, 10],
          borderWidth: 2,
          borderColor: vm.$store.getters.brown.light.a,
          backgroundColor: 'transparent',
          data: this.monthlyCollisions.map(function () { return vm.average })
        }
      ]
    },

    average () {
      return this.$store.getters[this.getters.average]
    },

    monthlyCollisions () {
      return (this.$store.getters[this.getters.monthlyCollisions]) ? this.$store.getters[this.getters.monthlyCollisions] : []
    },

    total () {
      return this.$store.getters[this.getters.total]
    },

    legend () {
      return [
        { label: 'Total collisions = ' + Number(this.total).toLocaleString('en-US') },
        { label: 'Average = ' + Number(this.average).toLocaleString('en-US') + ' per month' }
      ]
    },

    lineColor () {
      return this.$store.getters.yellow.default
    },

    backgroundColor () {
      return this.$store.getters.yellow.light.c
    },

    pointBackgroundColor () {
      return this.$store.getters.yellow.light.a
    },

    pointBorderColor () {
      return this.$store.getters.yellow.light.a
    }
  }
}
</script>

<style lang="scss">
@import "./src/sass/settings";

.monthly-collisions .line-chart {
  min-height: 300px;
  max-height: 400px;
}

.monthly-collisions .line-legend span {
    font-weight: 400;
    padding: 0.15em 0.25em;
}

.monthly-collisions .line-legend li:nth-child(1) span {
    background: $yellowLight3;
    border: solid 1px $yellowLight2;
    color: $yellowDark1;
}

.monthly-collisions .line-legend li:nth-child(2) span {
    background: $tan2;
    border: dashed 1px $brown1;
    color: $brown1;
}

@media (max-width: 1140px) {
  .monthly-collisions .line-legend li {
    display: block;
    float: none;
    margin: $spacing 0;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// MonthlyCollisions.vue?01999a44